<p-multiselect
  [selectAll]="null"
  [options]="contractSelectList"
  [ngModel]="selectedContracts"
  [loading]="saving()"
  [disabled]="saving()"
  (onChange)="emitFreightRates($event.value)"
  dataKey="rate.id"
  maxSelectedLabels="1"
  [showToggleAll]="false"
  [placeholder]="placeholder"
  selectedItemsLabel="{0} selected contracts"
>
</p-multiselect>
